import styled from "styled-components"; 

export const TopNotis = styled.div`
    width: 90%;
    height: 110px;
    .color1 {
        font-weight: bold;
    }
    .color2 {
        font-weight: 100;
    }
    .textos {
        font-size: 24px;
        margin-top: 50px;
    }
 


    @media (max-width: 760px) {
         height: 250px;

         .dropdown-container-v1  {
            width: 50%;
         }
         .dropdown-container-v2  {
            width: 50%;
         }
    }
    @media(max-width: 768px){
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        .textos {
            font-weight: 700;
            font-size: 16px;
            line-height: 150%;
            margin-top: 0;
            width: 100%;
            height: max-content;
        }
    }
   
`;

